import { render, staticRenderFns } from "./ImportarExcel.vue?vue&type=template&id=6c202ad0"
import script from "./ImportarExcel.vue?vue&type=script&lang=ts"
export * from "./ImportarExcel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports